<div class="container-fluid">
    <div class="row" id="titular">
        <div class="col-12">
            <h2>
                Nominar
            </h2>
            <p>
                Nomina a un personaje guatemalteco ilustre para el galardón 2024.
            </p>
        </div>
    </div>
    <div class="row" id="steps-nominacion">
        <div class="col-12">
            <steps-nominacion [step]="step"></steps-nominacion>
        </div>
    </div>
    <div class="row" id="form-content">
        <div class="col-12">
            <formulario-nominar [step]="step" [formulario]="formulario"></formulario-nominar>
        </div>
    </div>
    <div class="row" id="button-continuar">
        <div class="col-12 d-flex justify-content-center vertical-align-center">
            <button class="btn btn-primary btn-regresar" *ngIf="step > 1" (click)="regresar()">Regresar</button>
            <button class="btn btn-primary btn-continuar" (click)="siguiente()" *ngIf="step < 4"
                [disabled]="!camposValidos()">Continuar</button>
            <button class="btn btn-primary btn-continuar" (click)="nominar()" *ngIf="step === 4"
                [disabled]="!camposValidos()">Confirmar</button>
        </div>
    </div>
</div>